import { showDialog } from '../error_config';
import { useIns } from '../v2_helper/common'


/**
 * 店铺关闭时，从首页点击服务按钮跳转到PLP后需要弹窗提示，店铺已关闭无法下单
 * 为了避免在PLP页面重复提示，只有在首页点击一次按钮对应在PLP页进行一次提示
 */
const queue = []
export function useStoreCloseDialog() {
  const app = useIns();
  function push(serviceType) {
    if (serviceType.startsWith('SCHEDULED')) return;
    if (!app.storeOpened) {
      console.log('>>ConsumeCloseDialogPush type: ', serviceType)
      queue.push(serviceType)
    }
  }
  function consume() {
    const type = queue.pop();
    console.log('>>ConsumeCloseDialogPopup type: ', type)
    if (type) {
      showDialog(app, 8006, {})
      return true;
    }
    return false;
  }

  return { push, consume }
}
